export default "__VITE_ASSET__CvoWmelh__"